"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tv4 = require('tv4');
var _require = require('../../constant/relationship/label.constant'),
  NODE = _require.NODE;
var Access = /*#__PURE__*/function () {
  function Access(opt) {
    _classCallCheck(this, Access);
    this.id = null;
    this.displayName = null;
    this.tenantCode = null;
    this.campusCode = null;
    this.permission = null;
    this.type = null;
    if (opt) {
      this.fillObject(opt);
    }
  }
  _createClass(Access, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.id = opt.id || '';
      this.displayName = opt.displayName || '';
      this.tenantCode = opt.tenantCode || null;
      this.campusCode = opt.campusCode || null;
      this.permission = opt.permission || '';
      this.type = opt.type || '';
      if (opt.user) {
        this.id = opt.user.id || opt.user.userId;
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Access.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'access.schema.json',
        type: 'object',
        properties: {
          id: {
            type: 'string'
          },
          displayName: {
            type: 'string'
          },
          tenantCode: {
            type: 'string'
          },
          campusCode: {
            type: ['string', 'null']
          },
          permission: {
            "enum": ['ACKNOWLEDGE', 'AMEND', 'COMMENT', 'CONTACT', 'DELETE', 'EDIT', 'MEMBER', 'OWNER', 'READ', 'REVIEW', 'SUBMIT', 'WRITE']
          },
          type: {
            "enum": ['SYSTEM'].concat(_toConsumableArray(Object.values(NODE)))
          }
        },
        required: Object.keys(this)
      };
    }
  }, {
    key: "fromPerson",
    value: function fromPerson(user, permission) {
      return new Access({
        id: user.userId,
        displayName: "".concat(user.firstName, " ").concat(user.lastName),
        tenantCode: user.tenantCode,
        campusCode: user.campusCode,
        permission: permission,
        type: 'PERSON'
      });
    }
  }]);
  return Access;
}();
module.exports = Access;